module.exports = __webpack_public_path__ + "img/61_10.78322fa8.png";